import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetLoaderService {
  private assets: Array<AssetModel> = [];

  public load(asset: AssetModel): Observable<AssetModel> {
    return new Observable<AssetModel>((observer: Observer<AssetModel>) => {
      const existingAsset = this.assets.find((s) => s.src === asset.src);

      if (existingAsset && existingAsset.loaded) {
        observer.next(existingAsset);
        observer.complete();
      } else {
        this.assets = [...this.assets, asset];

        const assetElement = this.createElement(asset);

        assetElement.onload = () => {
          asset.loaded = true;
          observer.next(asset);
          observer.complete();
        };

        assetElement.onerror = (error: any) => {
          observer.error(`Couldn't load asset ${asset.src}`);
        };

        document.getElementsByTagName('body')[0].appendChild(assetElement);
      }
    });
  }

  private createElement(asset: AssetModel): HTMLElement {
    let assetElement;

    if (asset.type === AssetType.Script) {
      assetElement = document.createElement('script');
      assetElement.type = 'text/javascript';
      assetElement.src = asset.src;
    } else if ((asset.type === AssetType.StyleSheet)) {
      assetElement = document.createElement('link');
      assetElement.rel = 'stylesheet';
      assetElement.href = asset.src;
    }

    return assetElement;
  }
}

export interface AssetModel {
  src: string;
  loaded: boolean;
  type: AssetType;
}

export enum AssetType {
  Script,
  StyleSheet
}
